"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeGift = void 0;
var qs = require('qs');
var baseURL = '/free-gift-condition';
exports.freeGift = function (axios) {
    return {
        // 사은품 지급조건 등록
        postFreeGiftCondition: function (request) {
            return axios.post("" + baseURL, request.data);
        },
        // 사은품 지급조건 수정
        putFreeGiftConditionByGiveConditionNo: function (request) {
            return axios.put(baseURL + "/" + request.pathParams.giveConditionNo, request.data);
        },
        // 사은품 지급 조건 조회
        getFreeGiftConditionByGiveConditionNo: function (request) {
            return axios.get(baseURL + "/" + request.pathParams.giveConditionNo);
        },
        // 사은품 지급 몰 설정
        getFreeGiftConditionMallConfig: function () {
            return axios.get(baseURL + "/mall-config");
        },
        // 사은품 지급 몰 설정 수정
        putFreeGiftConditionMallConfigByMallNo: function (request) {
            var query = qs.stringify(request.params);
            return axios.put(baseURL + "/mall-config/" + request.pathParams.mallNo + "?" + query);
        },
        // 사은품 지급조건 검색
        getFreeGiftConditionSearch: function (request) {
            var query = qs.stringify(request.params);
            return axios.get(baseURL + "/search?" + query);
        },
        // 사은품 지급상태 수정
        putFreeGiftConditionByGiveConditionNoStatus: function (request) {
            var query = qs.stringify(request.params);
            return axios.put(baseURL + "/" + request.pathParams.giveConditionNo + "/status?" + query);
        }
    };
};
